(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-logos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(idSeccion) {
    var pista = document.getElementById('lc-pista-' + idSeccion);
    if (!pista) return;

    var inicioTactil = null;
    var offsetTactil = 0;
    var posActual = 0;
    var animando = true;
    var mitad = 0;

    function obtenerMitad() {
      return pista.scrollWidth / 2;
    }

    pista.addEventListener('touchstart', function (e) {
      inicioTactil = e.touches[0].clientX;
      animando = false;
      pista.style.animationPlayState = 'paused';
      var matrix = window.getComputedStyle(pista).transform;
      if (matrix && matrix !== 'none') {
        posActual = parseFloat(matrix.split(',')[4]) || 0;
      }
    }, { passive: true });

    pista.addEventListener('touchmove', function (e) {
      if (inicioTactil === null) return;
      var diff = e.touches[0].clientX - inicioTactil;
      offsetTactil = diff;
      var nuevaPos = posActual + diff;
      mitad = obtenerMitad();
      if (nuevaPos > 0) nuevaPos = nuevaPos - mitad;
      if (nuevaPos < -mitad) nuevaPos = nuevaPos + mitad;
      pista.style.transform = 'translateX(' + nuevaPos + 'px)';
    }, { passive: true });

    pista.addEventListener('touchend', function () {
      inicioTactil = null;
      pista.style.animationPlayState = 'running';
    });
  }

  function iniciarTodos() {
    document.querySelectorAll('[id^="lc-seccion-"]').forEach(function (sec) {
      iniciar(sec.id.replace('lc-seccion-', ''));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (document.getElementById('lc-seccion-' + e.detail.sectionId)) {
        iniciar(e.detail.sectionId);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cliente"] && !Shopify.designMode) return;
  try {
    
(function () {
  var COPIAS_LATERALES = 2;

  function calcularVentanaActivos() {
    var ancho = window.innerWidth;
    if (ancho >= 990) return 3;
    if (ancho >= 749) return 2;
    return 1;
  }

  function iniciarCarrusel(idSeccion) {
    var seccion = document.getElementById('tv-seccion-' + idSeccion);
    var pista = document.getElementById('tv-pista-' + idSeccion);
    var btnAnterior = document.getElementById('tv-anterior-' + idSeccion);
    var btnSiguiente = document.getElementById('tv-siguiente-' + idSeccion);

    if (!pista) return;

    var nOriginales = pista.children.length;
    if (nOriginales === 0) return;

    var originales = Array.from(pista.children);

    for (var c = 0; c < COPIAS_LATERALES; c++) {
      for (var i = nOriginales - 1; i >= 0; i--) {
        var clon = originales[i].cloneNode(true);
        clon.dataset.clonado = 'true';
        pista.insertBefore(clon, pista.firstChild);
      }
    }
    for (var c = 0; c < COPIAS_LATERALES; c++) {
      for (var i = 0; i < nOriginales; i++) {
        var clon = originales[i].cloneNode(true);
        clon.dataset.clonado = 'true';
        pista.appendChild(clon);
      }
    }

    var tarjetas = Array.from(pista.querySelectorAll('.tv-tarjeta'));
    var totalTarjetas = tarjetas.length;
    var inicioOriginales = COPIAS_LATERALES * nOriginales;
    var indiceActivo = inicioOriginales + Math.floor(nOriginales / 2);
    var muteado = true;
    var yaIniciado = false;

    function gap() {
      return parseFloat(getComputedStyle(pista).gap) || 10;
    }

    function calcularOffset(indice) {
      var anchoContenedor = pista.parentElement.getBoundingClientRect().width;
      var paddingIzq = parseFloat(getComputedStyle(pista).paddingLeft) || 0;
      var g = gap();
      var anchoActiva = tarjetas[indice].getBoundingClientRect().width;
      var anchoNormal = 0;
      var contados = 0;
      for (var i = 0; i < tarjetas.length; i++) {
        if (!tarjetas[i].classList.contains('tv-tarjeta--reproduciendo')) {
          anchoNormal += tarjetas[i].getBoundingClientRect().width;
          contados++;
        }
      }
      anchoNormal = contados > 0 ? anchoNormal / contados : anchoActiva;

      var offset = 0;
      for (var i = 0; i < indice; i++) {
        var w = tarjetas[i].classList.contains('tv-tarjeta--reproduciendo') ? anchoActiva : anchoNormal;
        offset += w + g;
      }
      offset -= (anchoContenedor - anchoActiva) / 2 - paddingIzq;
      return offset;
    }

    function mostrarPlay(tarjeta) {
      var bp = tarjeta.querySelector('.tv-boton-play');
      var bpa = tarjeta.querySelector('.tv-boton-pausa');
      if (bp) bp.style.display = '';
      if (bpa) bpa.style.display = 'none';
    }

    function mostrarPausa(tarjeta) {
      var bp = tarjeta.querySelector('.tv-boton-play');
      var bpa = tarjeta.querySelector('.tv-boton-pausa');
      if (bp) bp.style.display = 'none';
      if (bpa) bpa.style.display = '';
    }

    function aplicarIconoSonido(tarjeta) {
      var im = tarjeta.querySelector('.tv-icono-mute');
      var is = tarjeta.querySelector('.tv-icono-sonido');
      if (!im || !is) return;
      im.style.display = muteado ? '' : 'none';
      is.style.display = muteado ? 'none' : '';
    }

    function aplicarMuteGlobal() {
      tarjetas.forEach(function (t) {
        var v = t.querySelector('.tv-video');
        if (v) v.muted = muteado;
        aplicarIconoSonido(t);
      });
    }

    function activarVideo(video) {
      if (!video) return;
      if (video.src) return;
      var fuente = video.dataset.src;
      if (!fuente) return;
      video.preload = 'metadata';
      video.src = fuente;
      try { video.load(); } catch (e) {}
      var onReady = function () {
        video.removeEventListener('loadeddata', onReady);
        try { if (video.currentTime === 0) video.currentTime = 0.01; } catch (e) {}
      };
      video.addEventListener('loadeddata', onReady);
    }

    function desactivarVideo(video) {
      if (!video) return;
      if (!video.paused) {
        try { video.pause(); } catch (e) {}
      }
      if (video.src) {
        video.removeAttribute('src');
        try { video.load(); } catch (e) {}
      }
    }

    function actualizarVentanaActivos(indiceCentral) {
      var ventana = calcularVentanaActivos();
      var inicio = indiceCentral - ventana;
      var fin = indiceCentral + ventana;
      tarjetas.forEach(function (tarjeta, i) {
        var video = tarjeta.querySelector('.tv-video');
        if (i >= inicio && i <= fin) {
          activarVideo(video);
        } else {
          desactivarVideo(video);
        }
      });
    }

    function pausarTodosExcepto(indice) {
      tarjetas.forEach(function (tarjeta, i) {
        if (i === indice) return;
        var video = tarjeta.querySelector('.tv-video');
        if (!video) return;
        if (!video.paused) {
          try { video.pause(); } catch (e) {}
        }
        try { if (video.src) video.currentTime = 0; } catch (e) {}
        tarjeta.classList.remove('tv-tarjeta--reproduciendo');
        mostrarPlay(tarjeta);
      });
    }

    function reproducirEnIndice(indice) {
      var tarjeta = tarjetas[indice];
      if (!tarjeta) return;
      var video = tarjeta.querySelector('.tv-video');
      if (!video) return;
      activarVideo(video);
      video.muted = muteado;
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(function () { mostrarPausa(tarjeta); }).catch(function () { mostrarPlay(tarjeta); });
      } else {
        mostrarPausa(tarjeta);
      }
    }

    function moverA(indice) {
      pausarTodosExcepto(indice);
      indiceActivo = indice;
      tarjetas[indice].classList.add('tv-tarjeta--reproduciendo');
      actualizarVentanaActivos(indice);
      requestAnimationFrame(function () {
        var offset = calcularOffset(indice);
        pista.style.transform = 'translateX(' + (-offset) + 'px)';
        setTimeout(function () { reproducirEnIndice(indice); }, 80);
      });
    }

    function quizasResetearPosicion() {
      var distanciaIzq = indiceActivo;
      var distanciaDer = totalTarjetas - 1 - indiceActivo;
      var umbral = nOriginales;
      if (distanciaIzq >= umbral && distanciaDer >= umbral) return;

      var indiceLogico = ((indiceActivo - inicioOriginales) % nOriginales + nOriginales) % nOriginales;
      var nuevoIndice = inicioOriginales + indiceLogico;
      if (nuevoIndice === indiceActivo) return;

      var videoViejo = tarjetas[indiceActivo].querySelector('.tv-video');
      var tiempoActual = videoViejo && videoViejo.src ? videoViejo.currentTime : 0;
      var estabaPausado = videoViejo ? videoViejo.paused : true;

      pista.style.transition = 'none';
      tarjetas.forEach(function (t) { t.style.transition = 'none'; });

      tarjetas[indiceActivo].classList.remove('tv-tarjeta--reproduciendo');
      if (videoViejo) {
        if (!videoViejo.paused) { try { videoViejo.pause(); } catch (e) {} }
        try { if (videoViejo.src) videoViejo.currentTime = 0; } catch (e) {}
        mostrarPlay(tarjetas[indiceActivo]);
      }

      indiceActivo = nuevoIndice;
      tarjetas[indiceActivo].classList.add('tv-tarjeta--reproduciendo');
      actualizarVentanaActivos(indiceActivo);

      var offset = calcularOffset(indiceActivo);
      pista.style.transform = 'translateX(' + (-offset) + 'px)';
      pista.offsetHeight;

      var videoNuevo = tarjetas[indiceActivo].querySelector('.tv-video');
      if (videoNuevo) {
        var continuar = function () {
          videoNuevo.muted = muteado;
          try { videoNuevo.currentTime = tiempoActual; } catch (e) {}
          if (!estabaPausado) {
            var p = videoNuevo.play();
            if (p && typeof p.then === 'function') {
              p.then(function () { mostrarPausa(tarjetas[indiceActivo]); }).catch(function () {});
            } else {
              mostrarPausa(tarjetas[indiceActivo]);
            }
          }
        };
        if (videoNuevo.readyState >= 2) {
          continuar();
        } else {
          var unaVez = function () {
            videoNuevo.removeEventListener('loadeddata', unaVez);
            continuar();
          };
          videoNuevo.addEventListener('loadeddata', unaVez);
        }
      }

      requestAnimationFrame(function () {
        pista.style.transition = '';
        tarjetas.forEach(function (t) { t.style.transition = ''; });
      });
    }

    pista.addEventListener('transitionend', function (e) {
      if (e.target !== pista || e.propertyName !== 'transform') return;
      quizasResetearPosicion();
    });

    tarjetas.forEach(function (tarjeta, i) {
      var video = tarjeta.querySelector('.tv-video');
      var btnSonido = tarjeta.querySelector('.tv-boton-sonido');
      if (!video) return;

      video.muted = true;
      aplicarIconoSonido(tarjeta);

      tarjeta.querySelector('.tv-video-envoltorio').addEventListener('click', function (e) {
        if (e.target.closest('.tv-boton-sonido')) return;
        if (i === indiceActivo) {
          if (video.paused) {
            var p = video.play();
            if (p && typeof p.then === 'function') {
              p.then(function () { mostrarPausa(tarjeta); }).catch(function () {});
            }
          } else {
            video.pause();
            mostrarPlay(tarjeta);
          }
        } else {
          moverA(i);
        }
      });

      if (btnSonido) {
        btnSonido.addEventListener('click', function (e) {
          e.stopPropagation();
          muteado = !muteado;
          aplicarMuteGlobal();
        });
      }
    });

    btnAnterior.addEventListener('click', function () { moverA(indiceActivo - 1); });
    btnSiguiente.addEventListener('click', function () { moverA(indiceActivo + 1); });

    var inicioTactil = null;
    pista.addEventListener('touchstart', function (e) { inicioTactil = e.touches[0].clientX; }, { passive: true });
    pista.addEventListener('touchend', function (e) {
      if (inicioTactil === null) return;
      var diff = inicioTactil - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) moverA(diff > 0 ? indiceActivo + 1 : indiceActivo - 1);
      inicioTactil = null;
    });

    var timerResize = null;
    window.addEventListener('resize', function () {
      clearTimeout(timerResize);
      timerResize = setTimeout(function () {
        actualizarVentanaActivos(indiceActivo);
        pista.style.transition = 'none';
        pista.style.transform = 'translateX(' + (-calcularOffset(indiceActivo)) + 'px)';
        pista.offsetHeight;
        pista.style.transition = '';
      }, 100);
    });

    tarjetas[indiceActivo].classList.add('tv-tarjeta--reproduciendo');
    actualizarVentanaActivos(indiceActivo);

    requestAnimationFrame(function () {
      pista.style.transition = 'none';
      pista.style.transform = 'translateX(' + (-calcularOffset(indiceActivo)) + 'px)';
      pista.offsetHeight;
      pista.style.transition = '';
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !yaIniciado) {
            yaIniciado = true;
            reproducirEnIndice(indiceActivo);
          }
        });
      }, { threshold: 0.25 });
      observer.observe(seccion);
    } else {
      reproducirEnIndice(indiceActivo);
    }
  }

  function iniciarTodos() {
    document.querySelectorAll('[id^="tv-seccion-"]').forEach(function (sec) {
      var id = sec.id.replace('tv-seccion-', '');
      iniciarCarrusel(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var id = e.detail.sectionId;
      if (document.getElementById('tv-seccion-' + id)) iniciarCarrusel(id);
    });
  }

  // Contador animado en título
  document.querySelectorAll('[data-tv-titulo-raw]').forEach(function (el) {
    var raw = el.getAttribute('data-tv-titulo-raw');
    var match = raw.match(/(\d[\d.,]*)/);
    if (!match) return;
    var numStr = match[1].replace(/\./g, '').replace(/,/g, '');
    var numFinal = parseInt(numStr, 10);
    if (isNaN(numFinal)) return;
    var prefix = raw.slice(0, match.index);
    var suffix = raw.slice(match.index + match[1].length);
    var iniciado = false;
    function formatNum(n) { return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    function animar() {
      if (iniciado) return; iniciado = true;
      var duracion = 1500; var startTime = null;
      function paso(ts) {
        if (!startTime) startTime = ts;
        var prog = Math.min((ts - startTime) / duracion, 1);
        var eased = 1 - Math.pow(1 - prog, 3);
        var actual = Math.round(eased * numFinal);
        el.innerHTML = prefix + '<strong class="tv-titulo-numero">' + formatNum(actual) + '</strong>' + suffix;
        if (prog < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, obs) {
        if (entries[0].isIntersecting) { obs.disconnect(); animar(); }
      }, { threshold: 0.3 }).observe(el);
    } else { animar(); }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["confian-nosotros"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(idSeccion) {
    var pista = document.getElementById('cn-pista-' + idSeccion);
    var contenedorPuntos = document.getElementById('cn-puntos-' + idSeccion);
    var seccion = document.getElementById('cn-seccion-' + idSeccion);
    if (!pista || !seccion) return;

    var tarjetas = Array.from(pista.querySelectorAll('.cn-tarjeta'));
    var total = tarjetas.length;
    var paginaActual = 0;
    var timer = null;

    var intervaloStr = seccion.style.getPropertyValue('--cn-intervalo').trim();
    var intervalo = intervaloStr ? parseInt(intervaloStr) : 4000;

    function porVista() {
      return window.innerWidth >= 749 ? 3 : 4;
    }

    function totalPaginas() {
      return Math.ceil(total / porVista());
    }

    function construirPuntos() {
      if (!contenedorPuntos) return;
      contenedorPuntos.innerHTML = '';
      var n = totalPaginas();
      if (n <= 1) return;
      for (var i = 0; i < n; i++) {
        var btn = document.createElement('button');
        btn.className = 'cn-punto' + (i === 0 ? ' cn-punto--activo' : '');
        btn.setAttribute('aria-label', 'Página ' + (i + 1));
        (function (idx) {
          btn.addEventListener('click', function () {
            moverA(idx);
            reiniciarTimer();
          });
        })(i);
        contenedorPuntos.appendChild(btn);
      }
    }

    function actualizarPuntos() {
      if (!contenedorPuntos) return;
      var puntos = Array.from(contenedorPuntos.querySelectorAll('.cn-punto'));
      puntos.forEach(function (p, i) {
        p.classList.toggle('cn-punto--activo', i === paginaActual);
      });
    }

    function moverA(pagina) {
      var pv = porVista();
      paginaActual = (pagina + totalPaginas()) % totalPaginas();

      var gap = window.innerWidth >= 749 ? 16 : 8;
      var anchoPista = pista.parentElement.getBoundingClientRect().width;
      var anchoTarjeta = (anchoPista - gap * (pv - 1)) / pv;
      var offset = paginaActual * pv * (anchoTarjeta + gap);

      pista.style.transform = 'translateX(-' + offset + 'px)';
      actualizarPuntos();
    }

    function reiniciarTimer() {
      clearInterval(timer);
      timer = setInterval(function () {
        moverA(paginaActual + 1);
      }, intervalo);
    }

    var inicioTactil = null;
    pista.addEventListener('touchstart', function (e) {
      inicioTactil = e.touches[0].clientX;
    }, { passive: true });

    pista.addEventListener('touchend', function (e) {
      if (inicioTactil === null) return;
      var diff = inicioTactil - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        moverA(diff > 0 ? paginaActual + 1 : paginaActual - 1);
        reiniciarTimer();
      }
      inicioTactil = null;
    });

    var timerResize = null;
    window.addEventListener('resize', function () {
      clearTimeout(timerResize);
      timerResize = setTimeout(function () {
        construirPuntos();
        moverA(0);
        reiniciarTimer();
      }, 100);
    });

    construirPuntos();
    moverA(0);
    reiniciarTimer();
  }

  function iniciarTodos() {
    document.querySelectorAll('[id^="cn-seccion-"]').forEach(function (sec) {
      iniciar(sec.id.replace('cn-seccion-', ''));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (document.getElementById('cn-seccion-' + e.detail.sectionId)) {
        iniciar(e.detail.sectionId);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explora-disenos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function porVista() {
    return window.innerWidth >= 749 ? 3 : 1;
  }

  function iniciarGrupo(grupo, btnPrev, btnNext) {
    var pista = grupo.querySelector('.ed-pista');
    if (!pista) return;

    var tarjetas = Array.from(pista.querySelectorAll('.ed-tarjeta'));
    var total = tarjetas.length;
    var indice = 0;

    function moverA(nuevoIndice) {
      var pv = porVista();
      var maxIndice = Math.max(0, total - pv);
      indice = Math.min(Math.max(nuevoIndice, 0), maxIndice);

      var gap = window.innerWidth >= 749 ? 20 : 12;
      var anchoPista = pista.parentElement.getBoundingClientRect().width;
      var anchoTarjeta = pv === 3
        ? (anchoPista - gap * 2) / 3
        : anchoPista;
      var offset = indice * (anchoTarjeta + gap);

      pista.style.transform = 'translateX(-' + offset + 'px)';

      if (btnPrev) btnPrev.disabled = indice === 0;
      if (btnNext) btnNext.disabled = indice >= maxIndice;
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function () { moverA(indice - porVista()); });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () { moverA(indice + porVista()); });
    }

    var inicioTactil = null;
    pista.addEventListener('touchstart', function (e) {
      inicioTactil = e.touches[0].clientX;
    }, { passive: true });
    pista.addEventListener('touchend', function (e) {
      if (inicioTactil === null) return;
      var diff = inicioTactil - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) moverA(diff > 0 ? indice + 1 : indice - 1);
      inicioTactil = null;
    });

    var timerResize = null;
    window.addEventListener('resize', function () {
      clearTimeout(timerResize);
      timerResize = setTimeout(function () { moverA(0); }, 100);
    });

    grupo._moverA = moverA;
    moverA(0);
  }

  function iniciarSeccion(idSeccion) {
    var sliderArea = document.getElementById('ed-slider-area-' + idSeccion);
    var tabsContenedor = document.getElementById('ed-tabs-' + idSeccion);
    var btnPrev = document.getElementById('ed-prev-' + idSeccion);
    var btnNext = document.getElementById('ed-next-' + idSeccion);
    if (!sliderArea) return;

    var grupos = Array.from(sliderArea.querySelectorAll('.ed-grupo'));

    grupos.forEach(function (g) {
      iniciarGrupo(g, btnPrev, btnNext);
    });

    if (tabsContenedor) {
      var tabs = Array.from(tabsContenedor.querySelectorAll('.ed-tab'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('ed-tab--activo'); });
          tab.classList.add('ed-tab--activo');
          var grupoId = tab.dataset.grupo;
          grupos.forEach(function (g) {
            if (g.dataset.grupo === grupoId) {
              g.classList.add('ed-grupo--activo');
              if (g._moverA) g._moverA(0);
            } else {
              g.classList.remove('ed-grupo--activo');
            }
          });
        });
      });
    }
  }

  function iniciarTodos() {
    document.querySelectorAll('[id^="ed-seccion-"]').forEach(function (sec) {
      iniciarSeccion(sec.id.replace('ed-seccion-', ''));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (document.getElementById('ed-seccion-' + e.detail.sectionId)) {
        iniciarSeccion(e.detail.sectionId);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-principal"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarSlider(sliderId, puntosId, intervalo) {
    var slider = document.getElementById(sliderId);
    var contenedorPuntos = document.getElementById(puntosId);
    if (!slider) return;

    var slides = Array.from(slider.querySelectorAll('.hero-slide'));
    var puntos = contenedorPuntos ? Array.from(contenedorPuntos.querySelectorAll('.hero-punto')) : [];
    if (slides.length <= 1) return;

    var actual = 0;
    var timer = null;

    function irA(indice) {
      slides[actual].classList.remove('hero-slide--activo');
      if (puntos[actual]) puntos[actual].classList.remove('hero-punto--activo');
      actual = (indice + slides.length) % slides.length;
      slides[actual].classList.add('hero-slide--activo');
      if (puntos[actual]) puntos[actual].classList.add('hero-punto--activo');
    }

    function iniciarTimer() {
      clearInterval(timer);
      timer = setInterval(function () { irA(actual + 1); }, intervalo);
    }

    puntos.forEach(function (punto, i) {
      punto.addEventListener('click', function () {
        irA(i);
        iniciarTimer();
      });
    });

    iniciarTimer();
  }

  function iniciarTodos() {
    document.querySelectorAll('[id^="hero-seccion-"]').forEach(function (sec) {
      var id = sec.id.replace('hero-seccion-', '');
      var intervaloStr = sec.style.getPropertyValue('--hero-intervalo').trim();
      var intervalo = intervaloStr ? parseInt(intervaloStr) : 4000;
      iniciarSlider('hero-slider-mobile-' + id, 'hero-puntos-mobile-' + id, intervalo);
      iniciarSlider('hero-slider-desktop-' + id, 'hero-puntos-desktop-' + id, intervalo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var id = e.detail.sectionId;
      var sec = document.getElementById('hero-seccion-' + id);
      if (sec) {
        var intervaloStr = sec.style.getPropertyValue('--hero-intervalo').trim();
        var intervalo = intervaloStr ? parseInt(intervaloStr) : 4000;
        iniciarSlider('hero-slider-mobile-' + id, 'hero-puntos-mobile-' + id, intervalo);
        iniciarSlider('hero-slider-desktop-' + id, 'hero-puntos-desktop-' + id, intervalo);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-foto"] && !Shopify.designMode) return;
  try {
    
(function () {
  var esDesktop = function () { return window.innerWidth >= 749; };

  function iniciarSeccion(idSeccion) {
    var pista = document.getElementById('rv-pista-' + idSeccion);
    var btnPrev = document.getElementById('rv-prev-' + idSeccion);
    var btnNext = document.getElementById('rv-next-' + idSeccion);
    var dotsContenedor = document.getElementById('rv-dots-' + idSeccion);
    if (!pista) return;

    var tarjetas = Array.from(pista.querySelectorAll('.rv-tarjeta'));
    var total = tarjetas.length;
    var indice = 0;
    var autoplaySegundos = parseInt(pista.getAttribute('data-autoplay'), 10) || 6;
    var timerAutoplay = null;

    // Crear dots
    if (dotsContenedor) {
      dotsContenedor.innerHTML = '';
      tarjetas.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'rv-dot' + (i === 0 ? ' rv-dot--activo' : '');
        dot.setAttribute('aria-label', 'Ir a reseña ' + (i + 1));
        dot.addEventListener('click', function () { detenerAutoplay(); moverA(i); iniciarAutoplay(); });
        dotsContenedor.appendChild(dot);
      });
    }

    function actualizarDots() {
      if (!dotsContenedor) return;
      dotsContenedor.querySelectorAll('.rv-dot').forEach(function (d, i) {
        d.classList.toggle('rv-dot--activo', i === indice);
      });
    }

    function moverA(n) {
      indice = (n + total) % total;

      if (esDesktop()) {
        // Modo carrusel 3 tarjetas
        tarjetas.forEach(function (t, i) {
          t.classList.remove('rv-activa', 'rv-anterior', 'rv-siguiente');
          if (i === indice) {
            t.classList.add('rv-activa');
          } else if (i === (indice - 1 + total) % total) {
            t.classList.add('rv-anterior');
          } else if (i === (indice + 1) % total) {
            t.classList.add('rv-siguiente');
          }
        });
        pista.style.transform = '';
      } else {
        // Modo móvil: translateX normal
        tarjetas.forEach(function (t) {
          t.classList.remove('rv-activa', 'rv-anterior', 'rv-siguiente');
        });
        pista.style.transform = 'translateX(-' + (indice * 100) + '%)';
      }

      if (btnPrev) btnPrev.disabled = !esDesktop() && indice === 0;
      if (btnNext) btnNext.disabled = !esDesktop() && indice === total - 1;
      actualizarDots();
    }

    function iniciarAutoplay() {
      detenerAutoplay();
      timerAutoplay = setInterval(function () { moverA(indice + 1 < total ? indice + 1 : 0); }, autoplaySegundos * 1000);
    }

    function detenerAutoplay() {
      if (timerAutoplay) { clearInterval(timerAutoplay); timerAutoplay = null; }
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { detenerAutoplay(); moverA(indice - 1); iniciarAutoplay(); });
    if (btnNext) btnNext.addEventListener('click', function () { detenerAutoplay(); moverA(indice + 1); iniciarAutoplay(); });

    var inicioTactil = null;
    pista.addEventListener('touchstart', function (e) { inicioTactil = e.touches[0].clientX; }, { passive: true });
    pista.addEventListener('touchend', function (e) {
      if (inicioTactil === null) return;
      var diff = inicioTactil - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { detenerAutoplay(); moverA(diff > 0 ? indice + 1 : indice - 1); iniciarAutoplay(); }
      inicioTactil = null;
    });

    pista.parentElement.addEventListener('mouseenter', detenerAutoplay);
    pista.parentElement.addEventListener('mouseleave', iniciarAutoplay);

    // Al cambiar tamaño, recalcular
    window.addEventListener('resize', function () { moverA(indice); });

    moverA(0);
    iniciarAutoplay();
  }

  function iniciarTodos() {
    document.querySelectorAll('[id^="rv-seccion-"]').forEach(function (sec) {
      iniciarSeccion(sec.id.replace('rv-seccion-', ''));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (document.getElementById('rv-seccion-' + e.detail.sectionId)) iniciarSeccion(e.detail.sectionId);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
